var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArhiveLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.5V15.5C4.5 17.3856 4.5 18.3284 5.08579 18.9142C5.67157 19.5 6.61438 19.5 8.5 19.5H15.5C17.3856 19.5 18.3284 19.5 18.9142 18.9142C19.5 18.3284 19.5 17.3856 19.5 15.5V7.5M4.5 7.5H19.5M4.5 7.5H2.92857C2.76151 7.5 2.67798 7.5 2.61699 7.46168C2.58519 7.4417 2.5583 7.41481 2.53832 7.38301C2.5 7.32202 2.5 7.23849 2.5 7.07143V7.07143C2.5 6.06905 2.5 5.56786 2.72991 5.20195C2.8498 5.01115 3.01115 4.8498 3.20195 4.72991C3.56786 4.5 4.06905 4.5 5.07143 4.5H18.9286C19.931 4.5 20.4321 4.5 20.798 4.72991C20.9889 4.8498 21.1502 5.01115 21.2701 5.20195C21.5 5.56786 21.5 6.06905 21.5 7.07143V7.07143C21.5 7.23849 21.5 7.32202 21.4617 7.38301C21.4417 7.41481 21.4148 7.4417 21.383 7.46168C21.322 7.5 21.2385 7.5 21.0714 7.5H19.5",
    stroke: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.5H14.5",
    stroke: "#222222",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArhiveLight);
export default __webpack_public_path__ + "static/media/Arhive_light.e949114e456e2ed5b12e1fa5c785b77a.svg";
export { ForwardRef as ReactComponent };